// @ts-nocheck

import palette from '../palette';

export const TabBar = {
  backgroundColor: palette.black,
  Button: {
    default: {
      active: {
        color: palette.white,
        backgroundColor: palette.black,
      },
      passive: {
        color: palette.neutralgrey550,
        backgroundColor: palette.black,
      },
    },
    important: {
      active: {
        color: palette.white,
        backgroundColor: palette.red200,
      },
      passive: {
        color: palette.neutralgrey550,
        backgroundColor: palette.black,
      },
    },
    UnseenChangesTag: {
      backgroundColor: palette.yellowwinamax450,
    },
  },
};
